module.exports = __webpack_public_path__ + "img/congrats.ca9fe404.png";